module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title"
  }, [_vm._v("YOUR EXTREME CROCHET TOOLKIT")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("The standard crochet kit is what you’ll need for taking on extreme crochet, along with a few tweaks and some other essentials:")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("SCISSORS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Always useful. Make sure one pair is heavy duty enough to cope with cutting tougher yarns and threads.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("TAPESTRY/DARNING NEEDLE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The ends of larger yarns can be woven back into your work with your fingers, but you’ll still need a sturdy tapestry or darning needle with a blunt end. Make sure you find one with a really big eye for threading through those chunky yarns.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("STITCH MARKER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Useful for marking stitches, often the first one of a row or round. A large-sized one will be most useful, but you can always use a piece of coloured thread.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("ROW COUNTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Useful for counting your completed rows and rounds. Paper and pen work just fine, too.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("SEWING NEEDLE AND THREADS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sharp-ended and strong enough to pierce sturdy materials.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("TOY STUFFING/BEAN BAG PELLETS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("You’ll need these to stuff cushions and poufs. Each project will specify exactly what you’ll need.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("BUTTONS, RIBBONS AND OTHER PRETTIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Most crafters I know have a rather large stash of these sorts of things. Useful for creating interesting detail on your finished item.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead2"
  }, [_vm._v("HOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These are the most important pieces in your kit (alongside the yarn, of course). The projects in this book use big hooks. And some "), _c('i', [_vm._v("massive")]), _vm._v(" hooks. Each project will specify the hook size needed, but for this book you’re going to need:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("mm")]), _vm._v(" "), _c('th', [_vm._v("imperial")]), _vm._v(" "), _c('th', [_vm._v("US")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4.5mm")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("7")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9mm")]), _vm._v(" "), _c('td', [_vm._v("00")]), _vm._v(" "), _c('td', [_vm._v("M/N-13")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10mm")]), _vm._v(" "), _c('td', [_vm._v("000")]), _vm._v(" "), _c('td', [_vm._v("N/P-15")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12mm")]), _vm._v(" "), _c('td', [_vm._v("0000")]), _vm._v(" "), _c('td', [_vm._v("P/Q-16")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("15mm")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Q/19")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20mm")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("S/36")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25mm")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/I1-F2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-757beeb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolkit.vue
// module id = 69
// module chunks = 0